import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { useGetUserProjectParticipations } from '@/lib/actions/getUserProjectParticipations.ts'
import getProjectStatusIcon from '@/lib/helpers/getProjectStatusIcon.tsx'

export default function useCreateStagesProps() {
  const { projectParticipationsFlat } = useGetUserProjectParticipations()

  let properties: PopoverProperty[] = projectParticipationsFlat.map(projectParticipation => {
    const icon = getProjectStatusIcon(projectParticipation?.projectStage?.status).icon
    return {
      label: projectParticipation.projectStage?.name ?? '',
      value: String(projectParticipation.projectStage?.id),
      icon: icon,
    }
  })

  return properties
}
